import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const Body = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
`;

export const Main = styled.div`
  display: flex;
  width: 100%;
  grid-column: auto / span 6;

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    grid-column: auto / span 12;
  }
`;

export const Sidebar = styled.div`
  display: flex;
  grid-column: auto / span 3;
  margin-right: 20px;
  margin-left: 20px;
  justify-content: right;

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    margin-right: 60px;
  }

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;

export const SidebarContent = styled.div`
  bottom: 40px;
  position: sticky;
  top: 150px;
  width: 200px;
  align-self: flex-start;
`;
